"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCacheableGasRead = exports.createCacheableElecRead = void 0;
var uuid_1 = require("uuid");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var utils_1 = require("../../utils");
var customerReadTypes = {
    lifecycle: __generated__1.ReadingLifecycle.Inlife,
    type: __generated__1.ReadingType.Actual,
    source: __generated__1.FullMeterReadSource.ManualReadCustomer,
};
//Opening reads are industry source since they are submitted via Industry
var openingReadTypes = {
    lifecycle: __generated__1.ReadingLifecycle.ChangeOfSupplyOpening,
    type: __generated__1.ReadingType.Actual,
    source: __generated__1.FullMeterReadSource.Industry,
};
var wrapAsMeterReadEdge = function (read) {
    return ({
        __typename: 'MeterReadEdge',
        node: {
            __typename: 'ValidReading',
            reading: read,
        },
    });
};
var createCacheableElecRead = function (readId, data, opening) {
    if (readId === void 0) { readId = (0, uuid_1.v4)(); }
    if (opening === void 0) { opening = false; }
    return wrapAsMeterReadEdge(__assign({ __typename: 'ElectricityMeterRead', id: readId, dateTime: data.dateTime, meterSerialNumber: data.meterSerialNumber, registers: data.registers.map(function (_a) {
            var value = _a.value, registerId = _a.registerId, timeOfUseLabel = _a.timeOfUseLabel;
            return ({
                value: value,
                registerId: registerId || '',
                timingCategory: (0, utils_1.timeOfUseLabelToTimingCategory)(timeOfUseLabel),
            });
        }) }, (opening ? openingReadTypes : customerReadTypes)));
};
exports.createCacheableElecRead = createCacheableElecRead;
var createCacheableGasRead = function (readId, data, opening) {
    if (readId === void 0) { readId = (0, uuid_1.v4)(); }
    if (opening === void 0) { opening = false; }
    return wrapAsMeterReadEdge(__assign(__assign({ __typename: 'GasMeterRead', id: readId, dateTime: data.dateTime, meterSerialNumber: data.meterSerialNumber }, (opening ? openingReadTypes : customerReadTypes)), { value: data.registers[0].value }));
};
exports.createCacheableGasRead = createCacheableGasRead;
